export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  col?: boolean;
  alignItems?: 'start' | 'center' | 'end' | 'stretch';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-around'
    | 'space-between';
  wrap?: boolean;
  children?: React.ReactNode;
}

export const Flex = ({
  className,
  col,
  alignItems,
  justifyContent,
  wrap,
  children,
  ...rest
}: FlexProps) => (
  <div
    className={className ?? ''}
    style={{
      display: 'flex',
      flexDirection: col ? 'column' : 'row',
      alignItems: alignItems,
      justifyContent: justifyContent,
      flexWrap: wrap ? 'wrap' : 'nowrap',
    }}
    {...rest}
  >
    {children}
  </div>
);
